export default __webpack_public_path__ + "static/media/lines-sm.3ded52df.svg";